export const formatDateToLocalString = (params: {
  date?: string;
  options: Intl.DateTimeFormatOptions;
}) => {
  const date = params.date ? new Date(params.date) : new Date();
  return date.toLocaleString('en-US', params.options);
};
